import React from 'react';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ServiceButton from './ServiceButton';
import LineImage from '../../../../images/logo/sns/line-contained.png';
import { HOME, SIGN_UP } from '../../../front/routing';
import PersonPhoneImage from '../../../../images/features/local_delivery/person_phone.png';
import PersonWalkingImage from '../../../../images/features/local_delivery/person_walking.png';
import TitleImage from '../../../../images/features/local_delivery/cta_ttl.png';
import TitleSpImage from '../../../../images/features/local_delivery/cta_ttl_sp.png';
import { DIVIDER_REGISTER_COLOR, PRIMARY_COLOR } from '../constants';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import StyledTypography from './StyledTypography';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: PRIMARY_COLOR,

    padding: theme.spacing(4, 2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
    },
  },
  inner: {
    backgroundColor: 'white',
    borderRadius: 8,
    maxWidth: theme.breakpoints.values.lg - 100,
    position: 'relative',

    padding: theme.spacing(2),
    margin: `${theme.spacing(8)}px auto ${theme.spacing(4)}px`,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 4, 4),
      margin: `${theme.spacing(12)}px auto ${theme.spacing(4)}px`,
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
      margin: `${theme.spacing(8)}px auto ${theme.spacing(4)}px`,
    },
  },
  titleImage: {
    position: 'absolute',
    left: '50%',

    width: '100%',
    maxWidth: 500,
    top: -16,
    transform: 'translate(-50%, -100%)',
    [theme.breakpoints.up('md')]: {
      width: 800,
      maxWidth: 'none',
      top: 0,
      transform: 'translate(-50%, -50%)',
    },
  },
  descriptions: {
    textAlign: 'start',
    margin: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'center',
      margin: theme.spacing(4, 0),
    },
  },
  description: {
    fontSize: theme.typography.pxToRem(14),
  },
  inlineSp: {
    display: 'inline',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  buttons: {
    display: 'flex',

    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'stretch',
    },
  },
  buttonContainer: {
    paddingTop: theme.spacing(4),

    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
  buttonDescription: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 'auto',
    maxWidth: 420,
    position: 'relative',
  },
  image: {
    position: 'absolute',
    left: 20,
    bottom: 26,
    width: 38,
    [theme.breakpoints.up('sm')]: {
      left: 30,
      bottom: 30,
      width: 52,
    },
  },
  buttonSentences: {
    margin: theme.spacing(1.5, 0),
    paddingLeft: 46,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 16,
    },
  },
  boyButtonSentences: {
    margin: theme.spacing(0.5, 0),
    paddingLeft: 60,
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(1.5, 0),
      paddingLeft: 40,
    },
  },
  buttonSentence: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    lineHeight: 1.8,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  lineButton: {
    width: '100%',
    padding: theme.spacing(1.5, 0),
    [theme.breakpoints.up('sm')]: {
      padding: '22px 0',
    },
  },
  button: {
    width: '100%',
    padding: theme.spacing(2, 0),
    [theme.breakpoints.up('sm')]: {
      padding: '26px 0',
    },
  },
  lineLogo: {
    width: 32,
    height: 32,
    borderRadius: '50%',
  },
  divider: {
    borderRight: `3px dashed ${DIVIDER_REGISTER_COLOR}`,
    margin: theme.spacing(0, 2),
  },
}));

const Register = ({ authenticated }) => {
  const classes = useStyles();
  const match = useMediaQuery((theme) => theme.breakpoints.up('md'));
  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <h2>
          <img
            src={match ? TitleImage : TitleSpImage}
            alt="おてつたびに登録して、もっと地方が好きになる！"
            className={classes.titleImage}
          />
        </h2>
        <div className={classes.descriptions}>
          <StyledTypography
            className={clsx(classes.description, classes.inlineSp)}
          >
            「おてつたび」では、会員登録していただいた方向けに
          </StyledTypography>
          <StyledTypography
            className={clsx(classes.description, classes.inlineSp)}
          >
            もっと地方が好きになるイベント情報やお知らせ、おてつたびの募集情報をいち早く発信しています。
          </StyledTypography>
          <StyledTypography className={classes.description}>
            また会員登録すると、気になったおてつたび先を「フォロー」して、一覧にまとめることも可能です。
          </StyledTypography>
        </div>
        <div className={classes.buttons}>
          <div className={classes.buttonContainer}>
            <div className={classes.buttonDescription}>
              <img src={PersonPhoneImage} alt="" className={classes.image} />
              <div className={classes.buttonSentences}>
                <StyledTypography classes={{ root: classes.buttonSentence }}>
                  まずは、おてつたびについて
                </StyledTypography>
                <StyledTypography classes={{ root: classes.buttonSentence }}>
                  気軽に知りたい方はこちら
                </StyledTypography>
              </div>
              <ServiceButton
                classes={{ root: classes.lineButton }}
                rightArrow
                startIcon={
                  <img src={LineImage} alt="" className={classes.lineLogo} />
                }
                href={process.env.OFFICIAL_LINE_DIRECT_URL}
                target="_blank"
                rel="noreferrer"
              >
                LINEをお友達登録
              </ServiceButton>
            </div>
          </div>
          <div className={classes.divider} />
          <div className={classes.buttonContainer}>
            <div className={classes.buttonDescription}>
              <img src={PersonWalkingImage} alt="" className={classes.image} />
              <div className={classes.boyButtonSentences}>
                <StyledTypography classes={{ root: classes.buttonSentence }}>
                  おてつたび募集開始をいち早く
                </StyledTypography>
                <StyledTypography classes={{ root: classes.buttonSentence }}>
                  キャッチしたい方はこちら
                </StyledTypography>
              </div>
              <ServiceButton
                classes={{ root: classes.button }}
                rightArrow
                href={authenticated ? HOME : SIGN_UP}
              >
                おてつたびに会員登録
              </ServiceButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
